// Тонкий доступ композиции к клиентскому «чёрному ящику» (client-diag, connection-diag.ts). Транспорт
// владеет сетью и flush'ем на POST /diag/client-log; app-ui лишь ДОБАВЛЯЕТ свои маркеры через log()
// («композиция может добавлять свои маркеры» — connection-diag.log). Прямой fetch в app-ui запрещён
// стражем инв.2, поэтому диагностика доменных экранов (напр. содержимое буфера при вставке на iOS)
// идёт этим каналом. Вне реальной композиции (тесты) — no-op.

import { createContext, useContext, type ReactNode } from 'react'

export interface DiagApi {
  /** Записать событие в буфер диагностики (досылается на сервер, src=client-diag). */
  log: (ev: string, d?: Record<string, unknown>) => void
  /** Форсировать досыл буфера сейчас (не ждать 60-с таймера). */
  flush: () => void
}

const NOOP: DiagApi = { log: () => {}, flush: () => {} }

const DiagContext = createContext<DiagApi>(NOOP)

export function DiagProvider({ api, children }: { api: DiagApi; children: ReactNode }): JSX.Element {
  return <DiagContext.Provider value={api}>{children}</DiagContext.Provider>
}

export function useDiag(): DiagApi {
  return useContext(DiagContext)
}
